import React from "react";
import { Box, Stack } from "@mui/material";
import { ColorSystemProps } from "../../constants";
import { ClickEventType } from "../../types";
import { FullWidthTwoLineButton } from "../common/Buttons/FullWidthTwoLineButton";

/**
 * 소프트 제거된 장묘시설 상세 페이지에서 상세 섹션 대신 노출되는 안내.
 * 페이지(라우트)는 살아있고 헤더(브레드크럼 + 시설명)는 유지하되,
 * 상세 콘텐츠(비용·지도·FAQ 등)를 표기하지 않을 때 사용한다.
 * excludeFacilities 배열에 포함된 id에 대해 각 포털 facility [id] 페이지에서 렌더한다.
 *
 * 트래픽을 죽이지 않기 위해 견적 유입 CTA를 함께 노출한다.
 * "다른 장지 둘러보기"는 각 페이지 하단의 주변 장지 리스트 섹션을
 * isHidden 여부와 무관하게 항상 렌더하는 방식으로 별도 처리한다.
 */
export function FacilityHiddenNotice({
  companyname,
  ctaHref,
  mainColor,
  event,
}: {
  companyname?: string;
  ctaHref: string;
  mainColor: ColorSystemProps;
  event: ClickEventType;
}) {
  return (
    <Stack gap="24px" style={{ padding: "60px 0 40px" }}>
      <Stack
        gap="10px"
        alignItems="center"
        style={{ padding: "0 20px", textAlign: "center" }}
      >
        <Box
          component="h2"
          style={{
            fontSize: "18px",
            fontWeight: 700,
            color: "#252525",
            lineHeight: 1.4,
          }}
        >
          해당 시설 정보는 현재 제공되지 않습니다.
        </Box>
        <Box style={{ fontSize: "14px", color: "#888888", lineHeight: 1.5 }}>
          {companyname
            ? `${companyname}의 상세 정보는 현재 표시하지 않고 있습니다.`
            : "상세 정보는 현재 표시하지 않고 있습니다."}
        </Box>
      </Stack>
      <Stack gap="12px" padding="0 20px 20px 20px">
        <FullWidthTwoLineButton
          text="장지 비용 알아보기"
          description="다른 시설의 예상 비용도 확인해보세요"
          href={ctaHref}
          backgroundColor={mainColor.c400}
          event={event}
        />
      </Stack>
    </Stack>
  );
}
